import { parseCustomFieldAttributeValue } from '../parseCustomFieldAttributeValue';
/**
 * Combines attributes response with value response and returns normalized
 * CustomField type.
 */
export const getCustomFields = (attributes = [], values = {}, { includeArchived = false, includeDeactivated = false } = {}) => {
    return attributes
        .filter((attribute) => (includeArchived || !attribute.is_archived) &&
        (includeDeactivated || !attribute.is_deactivated))
        .map((attribute) => ({
        attribute,
        value: parseCustomFieldAttributeValue(attribute, values[attribute.id]),
    }));
};
